module.exports = __webpack_public_path__ + "img/l.65041a53.jpg";